import BetterWebStorage from 'better-web-storage';

export default new BetterWebStorage({
  local: true,
  prefix: '__z',
});
